<template>
  <div class="invoice-container">
    <nav class="add-navigation">
      <div @click="$router.push({name: 'system-admin-vendor-list'})" class="back-link">
        <svg class="icon" width="30px" height="30px" viewBox="0 0 30 30" version="1.1">
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to Vendors</p>
      </div>
    </nav>
    <filters-actions
      class="btn"
      @searchSecond="handleSearch"
      @filter="handleFilter"
      @searchByButton="search"
      @reset="reset"
      @add="$router.push({name: 'system-admin-vendor-product-add', params: {id: $route.params.vendor_uuid, name: $route.params.vendor_name}})"
      :search_second="{ placeholder: 'vendor account' }"
      :filter="{ options : searchTypes}"
      :search_button="true"
      :reset="true"
      :addButtton="{ text: 'Add Vendor Product' }"
    />
    <not-found v-if="isFound" />
    <template v-else>
      <div class="table_div" style="width:100%;overflow-x:auto;overflow-y:hidden">
        <table class="Invoice_table">
          <thead>
            <tr class="Invoice_table_header">
              <th style="min-width:250px">Vendor Product Name</th>
              <th style="min-width:200px; max-width: 300px">IP Address</th>
              <th style="min-width:200px; max-width: 300px">User</th>
              <th class="action">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr class="line" v-for="(vendor, k) in vendorProductsList" :key="k">
              <th class>{{vendor.vendor_product_name}}</th>
              <th>{{vendor.ip}}</th>
              <th>{{vendor.username}}</th>
              <th class="icon action">
                <svg
                  @click="() => toAddVendorRate(vendor)"
                  data-v-409d8da9
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                  class="svg-grey"
                >
                  <title data-v-409d8da9>Add Vendor Rate</title>
                  <path
                    data-v-409d8da9
                    d="M14.9776692,5 C9.47601504,5 5,9.47593985 5,14.977594 C5,20.4792481 9.47593985,24.955188 14.977594,24.955188 C20.4792481,24.955188 24.9551128,20.4792481 24.9551128,14.977594 C24.9551128,9.47593985 20.4793233,5 14.9776692,5 Z M14.9776692,23.8273684 C10.0978195,23.8273684 6.12781955,19.8574436 6.12781955,14.977594 C6.12781955,10.0977444 10.0978195,6.12781955 14.9776692,6.12781955 C19.8573684,6.12781955 23.8273684,10.0978195 23.8273684,14.977594 C23.8273684,19.8573684 19.8573684,23.8273684 14.9776692,23.8273684 Z M18.4926901,14.3550877 L15.7499108,14.3550877 L15.7499108,11.6578947 C15.7499108,11.2944737 15.4504601,11 15.0808967,11 C14.7113333,11 14.4118826,11.2944737 14.4118826,11.6578947 L14.4118826,14.3550877 L11.6690141,14.3550877 C11.2994507,14.3550877 11,14.6495614 11,15.0129825 C11,15.3764035 11.2994507,15.6708772 11.6690141,15.6708772 L14.4117934,15.6708772 L14.4117934,18.3681579 C14.4117934,18.7315789 14.7112441,19.0260526 15.0808075,19.0260526 C15.4503709,19.0260526 15.7498216,18.7315789 15.7498216,18.3681579 L15.7498216,15.6708772 L18.4926009,15.6708772 C18.8621643,15.6708772 19.161615,15.3764035 19.161615,15.0129825 C19.161615,14.6495614 18.8621643,14.3550877 18.4926901,14.3550877 Z"
                    id="path-1"
                  />
                </svg>
                <svg
                  @click="$router.push({name: 'system-admin-vendor-product-edit', params: {vendor_product_id: vendor.vendor_product_uuid}})"
                  class="svg-grey"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <path
                    d="M21.0636684,5 L16.5223005,5 C16.0222902,5 15.6155648,5.41380074 15.6155648,5.92250923 L15.6155648,19.7548339 C15.6155648,20.0601476 15.7303938,20.4698893 15.8885285,20.7291513 L18.1395544,24.4204428 C18.2910881,24.6688561 18.5293057,24.8114391 18.793057,24.8114391 C19.0568083,24.8114391 19.2949534,24.6688561 19.4465596,24.420369 L21.6974404,20.7292251 C21.8556477,20.4698155 21.9704767,20.0601476 21.9704767,19.7548339 L21.9704767,5.92250923 C21.9704041,5.41380074 21.5636062,5 21.0636684,5 Z M19.1930363,22.7361624 L18.3929326,22.7361624 L17.1373575,20.6773432 L20.4485389,20.6773432 L19.1930363,22.7361624 Z M16.7035751,19.5703321 L16.7035751,8.61188192 L18.2488705,8.61188192 L18.2488705,19.5703321 L16.7035751,19.5703321 Z M19.3370259,19.5703321 L19.3370259,8.61188192 L20.8823212,8.61188192 L20.8823212,19.5703321 L19.3370259,19.5703321 Z M20.8823212,6.10701107 L20.8823212,7.50487085 L16.7036477,7.50487085 L16.7036477,6.10701107 L20.8823212,6.10701107 Z M16.4717409,23.8886347 C16.7721969,23.8886347 17.0157824,24.1364576 17.0157824,24.4421402 C17.0157824,24.7478229 16.7721969,24.9956458 16.4717409,24.9956458 L8.56943005,24.9956458 C8.26897409,24.9956458 8.0253886,24.7478229 8.0253886,24.4421402 C8.0253886,24.1363838 8.26897409,23.8886347 8.56943005,23.8886347 L16.4717409,23.8886347 Z"
                    id="path-1"
                  />
                </svg>
                <svg
                  @click="deleteVendorAccount(vendor.vendor_product_uuid)"
                  class="svg-grey"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  version="1.1"
                >
                  <path
                    d="M22.0359259,7.63839416 L18.7919259,7.63839416 L18.7919259,6.35036496 C18.7919259,5.60576642 18.1771852,5 17.4215556,5 L12.5477037,5 C11.7920741,5 11.1773333,5.60576642 11.1773333,6.35036496 L11.1773333,7.63839416 L7.93333333,7.63839416 C7.42274074,7.63839416 7.00740741,8.04766423 7.00740741,8.55080292 L7.00740741,10.2229927 C7.00740741,10.7261314 7.42274074,11.1354015 7.93333333,11.1354015 L8.47111111,11.1354015 L8.47111111,23.6922628 C8.47111111,24.3966423 9.05266667,24.969635 9.76740741,24.969635 L20.2017778,24.969635 C20.9165185,24.969635 21.4980741,24.3966423 21.4980741,23.6922628 L21.4980741,11.1354745 L22.0359259,11.1354745 C22.5465185,11.1354745 22.9618519,10.7262044 22.9618519,10.2230657 L22.9618519,8.55080292 C22.9618519,8.04773723 22.5464444,7.63839416 22.0359259,7.63839416 Z M12.2884444,6.35036496 C12.2884444,6.21189781 12.4071852,6.09489051 12.5477037,6.09489051 L17.4215556,6.09489051 C17.5620741,6.09489051 17.6808148,6.21189781 17.6808148,6.35036496 L17.6808148,7.63839416 L12.2884444,7.63839416 L12.2884444,6.35036496 Z M20.386963,23.6923358 C20.386963,23.7912409 20.3021481,23.8748175 20.2017778,23.8748175 L9.76740741,23.8748175 C9.66703704,23.8748175 9.58222222,23.7912409 9.58222222,23.6923358 L9.58222222,11.1354745 L20.386963,11.1354745 L20.386963,23.6923358 Z M21.8507407,10.0405839 L8.11851852,10.0405839 L8.11851852,8.73328467 L21.8507407,8.73328467 L21.8507407,10.0405839 Z M11.7328889,22.3270073 C11.426,22.3270073 11.1773333,22.0818978 11.1773333,21.779562 L11.1773333,13.4284672 C11.1773333,13.1261314 11.426,12.8810219 11.7328889,12.8810219 C12.0397037,12.8810219 12.2884444,13.1261314 12.2884444,13.4284672 L12.2884444,21.779562 C12.2884444,22.0818978 12.0397037,22.3270073 11.7328889,22.3270073 Z M14.9846667,22.3270073 C14.6778519,22.3270073 14.4291111,22.0818978 14.4291111,21.779562 L14.4291111,13.4284672 C14.4291111,13.1261314 14.6777778,12.8810219 14.9846667,12.8810219 C15.2915556,12.8810219 15.5402222,13.1261314 15.5402222,13.4284672 L15.5402222,21.779562 C15.5402222,22.0818978 15.2915556,22.3270073 14.9846667,22.3270073 Z M18.2363704,22.3270073 C17.9294815,22.3270073 17.6808148,22.0818978 17.6808148,21.779562 L17.6808148,13.4284672 C17.6808148,13.1261314 17.9294815,12.8810219 18.2363704,12.8810219 C18.5432593,12.8810219 18.7919259,13.1261314 18.7919259,13.4284672 L18.7919259,21.779562 C18.7919259,22.0818978 18.5432593,22.3270073 18.2363704,22.3270073 Z"
                    id="path-1"
                  />
                </svg>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
    <div class="per-page">
      <span class="filter_by custom-row">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
          type="text"
          @input="changePerPage"
          v-model="per_page" :is-cross="false"
          class="choose-type perPage"
          placeholder="Select"
        >
          <option :value="item" v-for="(item,key) in pages" :key="key">{{item}}</option>
        </primary-select>
      </div>
    </div>
    <div v-if="!isFound" class="buttons-wrapper">
      <pagination-component
        @change-page="changePage($event)"
        :page="Page"
        :total="totalPage"
        :perPage="per_page"
        :qnt="vendorProducts.length"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddVendorRate from "../AddVendorRate.vue";

export default {
  components: {
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    FiltersActions: () => import("@/components/FiltersAndActions.vue"),
    NotFound: () => import("@/components/NotFound.vue"),
  },
  data: () => ({
    showDropDown: false,
    types: ["ALL", "MO", "MT"],
    searchTypes: [
      // { name: 'Username', value: 'username' },
      // { name: 'Ip', value: 'ip' },
      // { name: 'Adapter name', value: 'api_adapter_name' },
      // { name: 'Password', value: 'password' },
      // { name: 'Type', value: 'type' },
      { name: "Vendor product name", value: "vendor_product_name" },
      { name: "Rate table name", value: "rate_table_name" },
    ],
    searchType: "vendor_product_name",
    vendorProductType: null,
    Page: 0,
    Searched: "",
    type: "ALL",
    per_page: 10,
    pages: [10, 50, 100],
    isFound: false,
    vendorProductsList: [],
  }),
  computed: {
    ...mapGetters({
      vendorProducts: "vendorProduct/getVendorProducts",
      rates: "rates/getRates",
      totalPage: "vendorProduct/getTotalPages",
    }),
  },
  created() {
    this.setHeader();
    this.GetList();
  },
  methods: {
    ...mapActions({
      viewVendorProducts: "vendorProduct/getVendorProductList",
      viewAllRates: "rates/getRateList",
      delete: "vendorProduct/deleteVendorProduct",
    }),
    setHeader() {
      this.$store.commit(
        "setPageHeader",
        `${this.$route.params.vendor_name} Binds`
      );
    },
    changePerPage() {
      this.Page = 0;
      this.GetList();
    },
    changePage(page) {
      this.Page = page;
      this.GetList();
    },
    handleSearch(v) {
      this.Searched = v;
    },
    handleFilter(v) {
      this.searchType = v;
    },
    async toAddVendorRate(vendor) {
      await this.viewAllRates({
        vendor_uuid: this.$route.params.id,
        vendor_product_uuid: vendor.vendor_product_uuid,
      });
      // if(this.rates.length > 0) return
      this.showModal(vendor.rate_table_uuid);
    },
    showModal(id) {
      this.$modal.show(
        AddVendorRate,
        { rate_table_uuid: id },
        {
          draggable: true,
          width: "70%",
          height: "auto",
          scrollable: true,
          clickToClose: false,
        },
        {
          "before-close": this.beforeClose,
        }
      );
    },
    beforeClose() {},
    async GetList() {
      try {
        this.isFound = false;

        if (!this.$route.params.vendor_uuid) {
          this.isFound = true;
          return;
        }

        const res = await this.viewVendorProducts({
          // vendor_name: this.$route.params.vendor_product_name,
          vendorId: this.$route.params.vendor_uuid,
          page: this.Page,
          search: this.Searched.toLowerCase().trim() || "",
          searchType: this.searchType,
          type: this.vendorProductType,
          perPage: this.per_page,
        });
        if (!res.items.length) {
          this.isFound = true;
          return;
        }
        this.vendorProductsList = await res.items;
      } catch (err) {
        console.log("err", err.response.data);
        this.$snotify.error(
          err.response.data.error
            ? err.response.data.error.message
            : err.response.data.errors
        );
      }
    },
    search() {
      this.Page = 0;
      this.GetList();
    },
    searchByType() {
      this.GetList();
    },
    reset() {
      if (!this.Searched && !this.vendorProductType) {
        return;
      }
      this.vendorProductType = null;
      this.Searched = "";
      this.searchType = "username";
      this.GetList();
    },
    deleteVendorAccount(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You will not be able to recover this vendor product!",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
      }).then((result) => {
        if (result.value) {
          this.delete(id)
            .then(() => {
              this.$swal("Vendor product has been deleted.", "success");
              this.GetList();
            })
            .catch((err) => {
              this.$snotify.error(err.response.data.errors[0]);
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-container {

  padding: 0 20px;

  // .btn {
  //   // width: 210px;

  // }
  .Invoice_table {
    width: 100%;

    .action {
      width: 150px;
    }
    th {
      text-align: center;
    }
  }
  .per-page {
    display: flex;
    align-items: center;
    margin-top: 20px;
  }
  .perPage {
    width: 120px;
    margin-right: 15px;
  }
  .add-navigation {
    display: flex;
    align-items: flex-start;
    height: fit-content;
    margin-top: 20px;
    //margin-bottom: 20px;
    .back-link {
      width: 170px;
      //margin-top: 20px;
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin-bottom: 0;
      }
    }
    .search-container {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .right-wrapper {
        display: flex;
        align-items: center;
        width: fit-content;
        margin-right: 15px;
        .search-input {
          height: 40px;
          width: 360px;
          background-color: #ffffff;
        }
        .selects-wrapper {
          display: flex;
          align-items: center;
          width: fit-content;
          margin-right: 15px;
          .filter_by {
            height: 40px;
            width: 75px;
            color: #55616e;
            font-weight: normal;
            font-family: "Helvetica Neue";
            font-size: 14px;
            line-height: 25px;
            padding: 10px 0 0px 20px;
          }
          .filter_by_type {
            width: 105px;
          }
          .choose-type {
            height: 40px;
            width: 150px;
            padding: 0 0 0 10px;
            margin: 0 15px 0px 0;
            color: #55616e;
            font-weight: normal;
          }
        }
        .primary-button {
          width: 80px;
          margin-left: 15px;
        }
        .search_button {
          width: 87px;
        }
      }
      .buttons-wrapper {
        display: flex;
        align-items: center;

        .primary-button {
          height: 40px;
          width: 180px;
        }
      }
    }
  }
  @media only screen and (max-width: 1855px) {
    .add-navigation {
      .right-wrapprr {
        .select {
          margin-bottom: 20px;
        }
        .search-input {
          margin-bottom: 20px;
        }
      }
      .buttons-wrapper {
        margin-top: 0;
      }
    }
  }
}
table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
  th {
    border-bottom-width: 2px;
    color: white;
    padding-left: 10px;
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    border: 1px solid #dee2e6;
  }
}
table,
tr {
  width: 100%;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}

table {
  border-collapse: collapse;
}
.Invoice_table_popup {
  width: 75px;
}
.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
}
.Invoice_table_header th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 14%;
}
tbody th:first-child {
  padding-left: 20px;
  padding-right: 30px;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  //padding: 10px 15px 10px 0;
  margin: 0 auto;
  padding-right: 15px;
  height: 100%;
  float: right;
  .svg-grey {
    fill: #55616e;
    margin-right: 15px;
  }
}

.popup_content {
  display: none;
}
.popup_cta {
  cursor: pointer;
}
.Invoice_table_popup {
  text-align: right;
  position: relative;
  padding: 10px 15px 10px 0;
}
tbody th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  line-height: 20px;
  padding: 15px 10px;
  text-align: left;
}
table thead th:first-child {
  padding-left: 20px;
}
table th:first-child {
  padding-left: 20px;
}
tbody th.created_by {
  line-height: 20px;
  height: 30px;
  padding: 10px 0 10px 0;
}
tbody th.break {
  // max-width: 100px;
  word-wrap: break-word;
  padding-right: 15px;
  line-height: 20px;
  color: #55616e;
  font-family: "Helvetica Neue";
}
tbody th .did {
  width: 50px;
  height: 24px;
  line-height: 19px;
  margin-right: 2px;
}
tbody th .account {
  width: 75px;
  height: 24px;
  line-height: 19px;
  margin-right: 2px;
}
tbody th.icon {
  height: 100%;
  width: auto;
  padding: 7px 0;
  float: right;
  .svg-grey {
    fill: #55616e;
    height: 30px;
    width: 30px;
    margin-right: 5px;
  }
  .rate {
    width: 135px;
    height: 30px;
    font-size: 12px;
    line-height: 20px;
    border-radius: 100px;
    margin-right: 10px;
  }
}
.status {
  height: 10px;
  width: 10px;
  border-radius: 50%;
}
.running {
  background-color: #24e2b8;
}
.stop {
  background-color: #d2305b;
}
.hold {
  background-color: #ffc941;
}
.Invoice_table_popup.active .popup_content {
  display: block;
  position: absolute;
  right: 0;
  width: 240px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 10px 40px 0 rgba(0, 0, 0, 0.1);
  padding-left: 0;
  list-style-type: none;
  text-align: left;
}
.Invoice_table_popup.active .popup_content a {
  color: #55616e;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;
  font-family: "Helvetica Neue";
  padding: 10px 15px;
  display: inline-block;
}
.popup_image {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  vertical-align: middle;
  margin-right: 8px;
}
th.status:after {
  content: "";
  height: 10px;
  width: 10px;
  background-color: #24e2b8;
  position: absolute;
  border-radius: 50%;
  left: 12px;
  top: 17px;
}

th.user_active {
  text-align: left;
  position: relative;
  padding: 7px 0 7px 12px;
  width: 180px;
}
@media screen and (max-width: 1310px) {
  .table_div table.Invoice_table {
    width: 1200px;
  }
}
.table_div::-webkit-scrollbar {
  // width: 5px;
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

.table_div::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-image: -webkit-gradient(
    linear,
    left bottom,
    left top,
    color-stop(0.44, #51a3f3),
    color-stop(0.72, #51a3f3),
    color-stop(0.86, #51a3f3)
  );
}
</style>
